import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface Table2ColumnsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const Table2ColumnsIcon = ({ className, ...props }: Table2ColumnsIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.7539 2.94238C20.4739 2.94242 21.0575 3.52609 21.0576 4.24609V19.7539C21.0576 20.4739 20.4739 21.0576 19.7539 21.0576H4.24609C3.52609 21.0575 2.94244 20.4739 2.94238 19.7539V4.24609C2.94246 3.5261 3.52611 2.94246 4.24609 2.94238H19.7539ZM12.75 19.5576H19.5576V16.9043H12.75V19.5576ZM4.44238 19.5576H11.25V16.9043H4.44238V19.5576ZM12.75 15.4043H19.5576V12.75H12.75V15.4043ZM4.44238 15.4043H11.25V12.75H4.44238V15.4043ZM12.75 11.25H19.5576V8.5957H12.75V11.25ZM4.44238 11.25H11.25V8.5957H4.44238V11.25ZM12.75 7.0957H19.5576V4.44238H12.75V7.0957ZM4.44238 7.0957H11.25V4.44238H4.44238V7.0957Z"
      fill="currentColor"
    />
  </svg>
);

export default Table2ColumnsIcon;
